import { get, post, patch, remove } from '../utils/api';

export const createUser = (payload) => post('users', payload);

export const getAllUsers = () => get('users/all');

export const getNewUsers = () => get('users/new');

export const getUser = (payload) => get('users' + payload);

export const getCodeWars = (payload) => get(`codewars/${payload}`);

export const remindPassword = (payload) => get(`remind/${payload}`);

export const getUserById = (payload) => get(`users/${payload}`);

export const patchUserById = (payload) => patch(`users/${payload.id}`, payload);

export const deleteUserByIdApi = (payload) => remove(`users/${payload}`);